"use strict";
exports.__esModule = true;
exports.CANCEL_AUTH_CONTENT = void 0;
exports.CANCEL_AUTH_CONTENT = {
    TITLE: 'Don’t use Flex this month',
    MAIN_TEXT: 'You will pay rent on your own this month. By not using Flex this month, you understand that:',
    ITEMS: [
        'Flex will initiate a refund for your 1st payment immediately. It may take 1-3 business days for funds to become available.',
        'Flex will no longer pay your rent this month. Any payment already made by Flex may get returned.',
        'This choice assumes you do not want to use your line of credit to pay rent this month.',
        'Your scheduled payments for this month will be canceled.',
    ],
    CANNOT_UNDO: 'You can’t undo this action.',
    CONFIRM: 'By clicking confirm, I understand I will be responsible for my rent in full this month.',
    SUCCESS_MODAL_TITLE: 'Flex won’t pay your rent this month',
    SUCCESS_MODAL_TEXT: 'You are responsible to pay your rent on your own this month.'
};
